import {BaseService} from "./base.service";

class CategoryLaboratoryService extends BaseService {

    constructor() {
        super('api/category-laboratory')
    }

}

export const categoryLaboratoryService = new CategoryLaboratoryService();
